import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/tags/")({
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith("tags")) {
      throw redirect({
        to: "/workspaces/$workspace_id/tags/device-tags",
        params: {
          workspace_id: params.workspace_id,
        },
      });
    }
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
});
